/* Check is the timestamp is younger or equal to 2 min */
export function checkIsStoreFresh(lastLoadTimestamp: number | null): boolean {
  return lastLoadTimestamp && (Date.now() - lastLoadTimestamp) / 1000 / 60 <= 2;
}
